const createIDedSelector = (id: string | number, prefix: string) =>
  `${prefix}${String(id)}`;

export const urlTestIDs = {
  shorten: {
    modalButton: 'e2e_url-shorten-modal-button',
    url: 'e2e_url-shorten-url',
    label: 'e2e_url-shorten-label',
    customIdentifier: 'e2e_url-shorten-custom-identifier',
    button: 'e2e_url-shorten-button',
  },
  list: {
    container: 'e2e_url-list-container',
    table: {
      actions: (url: string) =>
        createIDedSelector(url, 'e2e_url-list-table-actions-'),
      delete: (url: string) =>
        createIDedSelector(url, 'e2e_url-list-table-delete-'),
    },
    warningModal: {
      confirmButton: 'e2e_url-list-warning-modal-confirm-button',
      cancelButton: 'e2e_url-list-warning-modal-cancel-button',
    },
  },
};
